/**
 * Created by portiz on 8/24/2018.
 */
import React from 'react';
import LoadingIcon from './loading-icon';

/** Class that handle the full loading window.
 * The active or non active are set in the parent
 */
class LoadingFullWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
    }

    /**
     * Hide or shows the loading window
     */
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <div className="loader-full-window">
                <LoadingIcon/>
            </div>
        );
    }
}

export default LoadingFullWindow;


// WEBPACK FOOTER //
// ./src/components/loader-windows/loader-full-window.js